import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/reducers';
import { AuthState } from 'store/slices/auth';

export const authSelector = (state: RootState) => state.auth;

export const nameSelector = createSelector<RootState, AuthState, string>(
  state => authSelector(state),
  auth => auth.name
);

export const usernameSelector = createSelector<RootState, AuthState, string>(
  state => authSelector(state),
  auth => auth.username
);

export const imageSelector = createSelector<RootState, AuthState, string>(
  state => authSelector(state),
  auth => auth.image
);

export const emailSelector = createSelector<RootState, AuthState, string>(
  state => authSelector(state),
  auth => auth.email
);

export const isAuthSelector = createSelector<RootState, AuthState, boolean>(
  state => authSelector(state),
  auth => auth.isAuth
);
